import ActionTypes from './actionTypes';

export const init = () => ({
  type: ActionTypes.INIT,
});

export const fetch = (from, to, status) => ({
  type: ActionTypes.FETCH,
  payload: {
    from,
    to,
    status,
  },
});

export const fetched = (data) => ({
  type: ActionTypes.FETCHED,
  payload: {
    data,
  },
});

export const markAsPaid = (refId, trxId) => ({
  type: ActionTypes.MARK_AS_PAID,
  payload: {
    refId,
    trxId,
  },
});

export const download = (refId) => ({
  type: ActionTypes.DOWNLOAD,
  payload: {
    refId,
  },
});
